import { render, staticRenderFns } from "./TransactionView.vue?vue&type=template&id=0b220ee7&scoped=true&"
import script from "./TransactionView.vue?vue&type=script&lang=js&"
export * from "./TransactionView.vue?vue&type=script&lang=js&"
import style0 from "./TransactionView.vue?vue&type=style&index=0&id=0b220ee7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b220ee7",
  null
  
)

export default component.exports